import type { ComponentType } from 'react'
import { PaletteIcon } from '@/components/icons/lucide-palette'
import { VideoIcon } from '@/components/icons/lucide-video'
import { MusicIcon } from '@/components/icons/lucide-music'
import { WrenchIcon } from '@/components/icons/lucide-wrench'
import { LayoutGridIcon } from '@/components/icons/lucide-layout-grid'

type ExploreIcon = ComponentType<{ size?: number; className?: string }>

export interface WorkflowExploreCategory {
  query: string
  navLabel: string
  cardTitle: string
  cardDescription: string
  Icon: ExploreIcon
}

/** Workflow “Browse by category” / sidebar / upload — `query` is the `workflow_categories.slug` and explore URL param. */
export const WORKFLOW_EXPLORE_CATEGORIES: WorkflowExploreCategory[] = [
  {
    query: 'image-gen',
    navLabel: 'Image generation',
    cardTitle: 'Image generation',
    cardDescription: 'Generate images with AI',
    Icon: PaletteIcon,
  },
  {
    query: 'video',
    navLabel: 'Video processing',
    cardTitle: 'Video processing',
    cardDescription: 'Edit and process videos',
    Icon: VideoIcon,
  },
  {
    query: 'audio',
    navLabel: 'Audio processing',
    cardTitle: 'Audio processing',
    cardDescription: 'Work with audio content',
    Icon: MusicIcon,
  },
  {
    query: 'utility',
    navLabel: 'Utilities',
    cardTitle: 'Utilities',
    cardDescription: 'Helper workflows',
    Icon: WrenchIcon,
  },
  {
    query: 'other',
    navLabel: 'Other',
    cardTitle: 'Other',
    cardDescription: 'Everything else',
    Icon: LayoutGridIcon,
  },
]
